module.exports = __webpack_public_path__ + "img/sl-9.webp";